import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=56336d9f&scoped=true&"
import script from "./InputRadio.vue?vue&type=script&lang=js&"
export * from "./InputRadio.vue?vue&type=script&lang=js&"
import style0 from "./InputRadio.vue?vue&type=style&index=0&id=56336d9f&lang=scss&scoped=true&"
import style1 from "./InputRadio.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56336d9f",
  null
  
)

export default component.exports